<template>
  <v-dialog v-model="dialog" width="800px" persistent>
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("CRUD.chooseInfo", [$t("Supplier.ObjectName")]) }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-row dense class="mx-5">
        <v-col cols="12" sm="5">
          <v-row dense align="center" class="pa-1">
            <SearcherKeyword
              ref="keyword"
              v-model="supplierKeyword"
              @text="KeyWord = $event"
              :label="$t('Supplier.Keyword')"
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="2" align-self="center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                small
                text
                class="caption font-weight-bold grey--text"
                color="primary"
                @click.stop="onSearch()"
              >
                <v-icon small class="pe-1">fa-search</v-icon>
                {{ $t("Search.search") }}
              </v-btn>
            </template>
            <span>{{ $t("Search.searchTip") }}</span>
          </v-tooltip>
        </v-col>
        <v-col cols="12" sm="6">
          <v-row dense align="center" class="pa-1" v-if="!signleFlg">
            <div
              class="caption grey--text input-chip-group-label"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ $t("Material.choose") }}
            </div>
            <v-chip-group v-model="chooseFlgs" column multiple class="mx-1">
              <v-chip
                small
                label
                filter
                class="mx-1"
                color="primary"
                text-color="white"
                :key="1"
                :value="1"
                >{{ $t("CRUD.choosed") }}</v-chip
              >
              <v-chip
                small
                label
                filter
                class="mx-1"
                color="grey"
                text-color="white"
                :key="0"
                :value="0"
                >{{ $t("CRUD.unchoose") }}</v-chip
              >
            </v-chip-group>
          </v-row>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="supplierItems"
        :loading="loading"
        multi-sort
        class="elevation-0 px-6"
        v-resize="resizeHeader"
        height="340px"
        :footer-props="footerProps"
      >
        <template v-slot:header.choose>
          <span v-if="signleFlg">
             {{ $t("TableHeaders.actions") }}
          </span>
          <v-checkbox
            v-else
            class="mt-2 mb-n3"
            color="primary"
            :indeterminate="
              suppliers.find((detail) => detail.choose != chooseAll)
                ? true
                : false
            "
            v-model="chooseAll"
            :true-value="1"
            :false-value="0"
          >
            <template v-slot:label>
              <span class="caption ms-n2">
                {{ $t("CRUD.chooseAll") }}
              </span>
            </template>
          </v-checkbox>
        </template>
        <template v-slot:item.stop_flg="{ item }">
          <v-chip
              small
              label
              :color="item.stop_flg | stopFlgColor"
              :text-color="item.stop_flg | stopFlgTextColor"
          >
            {{ item.stop_flg | stopFlgText }}
          </v-chip>
          <br />
          <span class="red--text" v-if="item.show_licence_notice">
                {{ $t("Supplier.Fields.licence_notice") }}
              </span>
        </template>
        <template v-slot:item.choose="{ item }">
          <div class="d-flex mt-n2 mb-n3" v-if="signleFlg">
            <v-btn
                color="primary"
                small
                dense
                @click="
                $emit('confirm', item);
                dialog = false;
              "
            >
              {{ $t("Stock.Fields.choose") }}
            </v-btn>
          </div>
          <div class="d-flex mt-n2 mb-n3" v-else>
            <v-checkbox
              color="primary"
              v-model="item.choose"
              :true-value="1"
              :false-value="0"
              :disabled="item.disabled"
            >
              <template v-slot:label>
                <span class="caption ms-n2">
                  {{ $t(item.choose ? "CRUD.choosed" : "CRUD.unchoose") }}
                </span>
              </template>
            </v-checkbox>
          </div>
        </template>
      </v-data-table>
      <v-card-actions>
        <span class="caption">
          {{ $t("CRUD.chooseCount", [choosedLength, newChoosedArr.length]) }}
        </span>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          class="elevation-1"
          @click="dialog = false"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn v-if="!signleFlg" color="accent" @click="saveChoose()">
          {{ $t("CRUD.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Suppliers from "@/api/suppliers";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";

export default {
  name: "SuppliersSelectsDialog",

  props: {
    fullField: Boolean,
    value: Boolean,
    changed: Array,
    supplierIds: Array,
    options: Object,
    disabledIds: Array,
    type: Number,
    signleFlg: Boolean,
  },

  components: {
    SearcherKeyword,
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("Supplier.Fields.supplier_code"),
          align: "start",
          sortable: false,
          value: "supplier_code",
        },
        {
          text: i18n.t("Supplier.Fields.supplier_name"),
          align: "start",
          sortable: false,
          value: "supplier_name",
        },
        {
          text: i18n.t("Supplier.Fields.manager_name"),
          align: "start",
          sortable: false,
          value: "manager_name",
        },
        {
          text: i18n.t("Supplier.Fields.manager_tel"),
          align: "start",
          sortable: false,
          value: "manager_tel",
        },
        {
          text: i18n.t("Supplier.Fields.status"),
          align: "center",
          sortable: false,
          value: "stop_flg",
        },
        {
          text: i18n.t("CRUD.chooseAll"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "choose",
        },
      ];
    },

    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },

    supplierItems() {
      //前端搜索
      return this.suppliers.filter(
        (item) =>
          ((this.chooseFlgs.length &&
            (item.choose
              ? this.chooseFlgs.find((flg) => flg == item.choose) !=
                  undefined || !item.disabled
              : this.chooseFlgs.find((flg) => flg == item.choose) !=
                undefined)) ||
            !this.chooseFlgs.length) &&
          ((this.supplierKeyword && (item.supplier_name.indexOf(this.supplierKeyword) > -1) || item.supplier_code.indexOf(this.supplierKeyword) > -1) ||
            !this.supplierKeyword)
      );
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    suppliers: [],
    supplierKeyword: "",
    chooseFlgs: [0],
    itemsPerPageOptions: 10,
    supplierIdsChoosed: [],
    supplierIdsDisabled: [],
    chooseAll: 0,
    newChoosedArr: [],
    choosedLength: 0,
    fetchTimestamp: 0, //第一次获取供应商列表的时间
  }),

  methods: {
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },
    onSearch() {
      this.supplierKeyword = this.KeyWord;
    },

    //获取供应商列表
    getSuppliersFromAPI() {
      if (new Date().getTime() - this.fetchTimestamp < 30 * 60 * 1000) {
        this.suppliers = this.suppliers.map((supplier) => {
          if (
            this.supplierIdsChoosed.indexOf(supplier.id) > -1 &&
            (!supplier.choose || !supplier.disabled)
          ) {
            supplier = Object.assign({}, supplier, {
              choose: 1,
              disabled: true,
            });
          } else if (
            this.supplierIdsChoosed.indexOf(supplier.id) == -1 &&
            (supplier.choose == 1 || supplier.disabled)
          ) {
            if (supplier.choose == 1) {
              supplier.choose = 0;
            }
            if (supplier.disabled) {
              supplier.disabled = false;
            }
          }
          if (this.supplierIdsDisabled.indexOf(supplier.id) > -1) {
            supplier.disabled = true;
          }

          return supplier;
        });
        return;
      }

      let options = this.options;
      if (!this.fullField) {
        var fieldFilter = [
          "id",
          "supplier_code",
          "supplier_name",
          "stop_flg",
          "manager_name",
          "manager_tel",
        ];
        options = Object.assign(
            {
              fieldFilter: fieldFilter,
              // 仅筛选少许必要字段
            },
            this.options
        );
      }
      if (this.type) {
        options.type = this.type
      }

      Suppliers.fetchAllNoPaging(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.suppliers = response.data.suppliers.map((supplier) => {
              //默认勾选
              if (this.supplierIdsChoosed.indexOf(supplier.id) > -1) {
                supplier = Object.assign({}, supplier, {
                  choose: 1,
                  disabled: true,
                });
              } else {
                if (supplier.choose == 1 || !supplier.choose) {
                  supplier.choose = 0;
                }
                if (supplier.disabled) {
                  supplier.disabled = false;
                }
              }
              if (this.supplierIdsDisabled.indexOf(supplier.id) > -1) {
                supplier.disabled = true;
              }
              return supplier;
            });

            this.fetchTimestamp = new Date().getTime();
          }
        }.bind(this)
      );
    },

    saveChoose() {
      this.dialog = false;
      this.$emit("confirm", this.newChoosedArr);
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = this.value;
          if (this.supplierIds && this.supplierIds.length) {
            this.supplierIdsChoosed = JSON.parse(
              JSON.stringify(this.supplierIds)
            );
          } else {
            this.supplierIdsChoosed = [];
          }
          if (this.disabledIds && this.disabledIds.length) {
            this.supplierIdsDisabled = JSON.parse(
              JSON.stringify(this.disabledIds)
            );
          }

          this.choosedLength = this.supplierIdsChoosed.length;
          this.getSuppliersFromAPI();
        }
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.newChoosedArr = [];
          this.supplierKeyword = "";
          this.chooseFlgs = [0];
          this.publicFlgs = [1];
          this.chooseAll = false;
        }
        this.$emit("input", this.dialog);
      },
    },
    chooseAll: {
      handler() {
        this.suppliers = this.suppliers.map(
          function (e) {
            var item = this.supplierItems.find((m) => m.id == e.id && !e.disabled);
            if (item) e.choose = this.chooseAll ? 1 : 0;
            return e;
          }.bind(this)
        );
      },
    },
    suppliers: {
      deep: true,
      handler() {
        //整理新增商品
        this.suppliers.forEach((supplier) => {
          if (
            supplier.choose &&
            !this.supplierIdsChoosed.includes(supplier.id) &&
            !this.newChoosedArr.find(
              (new_choosed) =>
                new_choosed.id == supplier.id ||
                new_choosed.supplier_id == supplier.id
            )
          ) {
            this.newChoosedArr.push(supplier);
            this.choosedLength = this.choosedLength + 1;
          } else if (
            !supplier.choose &&
            this.newChoosedArr.find(
              (new_choosed) =>
                new_choosed.id == supplier.id ||
                new_choosed.supplier_id == supplier.id
            )
          ) {
            this.newChoosedArr.splice(
              this.newChoosedArr.findIndex(
                (new_choosed) =>
                  new_choosed.id == supplier.id ||
                  new_choosed.supplier_id == supplier.id
              ),
              1
            );
            this.choosedLength = this.choosedLength - 1;
          }
        });
      },
    },
  },
};
</script>